import { TEXT_POSITIONS } from '@api/constants';
import * as utils from '@utils/form';
import { IMAGE_SIZE } from '@api/media/constants';
import { TEXT_COLOURS, WA_BLACK } from '@constants';

export const FORM_FIELD = {
  ARTICLE: {
    name: 'article',
    label: 'Title:',
    rules: [{ required: true, message: 'This field is required' }],
    serialize: utils.relatedEntitySerializerForContentIdOrId,
  },
  IMAGE: {
    name: 'image',
    label: 'Article image:',
    rules: [{ required: true, message: 'An image is required' }],
    size: IMAGE_SIZE['2000x714'],
    serialize: utils.imageSerialize,
    deserialize: utils.imageDeserialize,
  },
  TITLE: {
    name: 'title',
    label: 'Title:',
    placeholder: 'Enter a title for the article',
    rules: [{ required: true, message: 'Title is required' }],
  },
  SUBTITLE: {
    name: 'subtitle',
    label: 'Subtitle:',
    placeholder: 'Enter a subtitle',
    rules: [{ required: true, message: 'Subtitle is required' }],
  },
  DESCRIPTION: {
    name: 'description',
    label: 'Description:',
    placeholder: 'Enter a description',
    rules: [{ required: true, message: 'Description is required' }],
  },
  URL_TEXT: {
    name: 'urlText',
    label: 'URL Text:',
    placeholder: 'Enter the text URL redirecting to URL',
    rules: [{ required: true, message: 'URL text is required' }],
  },
  URL: {
    name: 'url',
    label: 'URL:',
    placeholder: 'Enter the article URL',
    rules: [
      { required: true, message: 'URL is required' },
      { type: 'url', message: "Doesn't look like a valid URL" },
    ],
  },
  TEXT_POSITION: {
    name: 'textPosition',
    label: 'Text position:',
    positions: TEXT_POSITIONS,
  },
  TEXT_COLOR: {
    name: 'textColour',
    label: 'Text colour:',
    colors: [...TEXT_COLOURS],
  },
  BACKGROUND_COLOUR: {
    name: 'backgroundColour',
    label: 'Background colour:',
    colors: [WA_BLACK],
    rules: [{ required: true, message: 'News background colour is required' }],
  },
  BACKGROUND: {
    name: 'desktopBackgroundImage',
    label: 'Desktop Background:',
    buttonText: 'CHOOSE A NEW IMAGE',
    rules: [{ required: true, message: 'News background image is required' }],
    size: IMAGE_SIZE['1440x576'],
    serialize: utils.imageSerialize,
    deserialize: utils.imageDeserialize,
    deserializeError: utils.deserializeErrorRelatedField,
  },
  MOBILE_BACKGROUND: {
    name: 'mobileBackgroundImage',
    label: 'Mobile Background:',
    buttonText: 'CHOOSE A NEW IMAGE',
    rules: [{ required: true, message: 'News background image is required' }],
    size: IMAGE_SIZE['390x576'],
    serialize: utils.imageSerialize,
    deserialize: utils.imageDeserialize,
    deserializeError: utils.deserializeErrorRelatedField,
  },
};
export const FORM_FIELDS = Object.values(FORM_FIELD);

export const MODE = {
  MANUAL: {
    value: 'manual',
    label: 'Add the article manually',
  },
  EXISTING: {
    value: 'existing',
    label: 'Add an existing article',
  },
};
export const MODES = Object.values(MODE);

export const INITIAL_VALUES = {
  [FORM_FIELD.TEXT_COLOR.name]: FORM_FIELD.TEXT_COLOR.colors[0],
  [FORM_FIELD.TEXT_POSITION.name]: FORM_FIELD.TEXT_POSITION.positions[0].key,
};
